"use strict";

module.exports = {
  appUSurfaceShadow: '#ffffff',
  appUSurfaceTouchablehighlight: '#ddeeff',
  appUSurfaceTouchablehighlightNegative: 'rgba(17, 21, 21, 0.16)',
  bColordanger: '#dd2222',
  bColordangerlight: '#ffcccc',
  bColorinfo: '#4499ee',
  bColorinfolight: '#eeffff',
  bColorneutral01: '#ffffff',
  bColorneutral02: '#f8f8f8',
  bColorneutral03: '#eeeeee',
  bColorneutral04: '#cccccc',
  bColorneutral05: '#aabbbb',
  bColorneutral06: '#778888',
  bColorneutral07: '#556666',
  bColorneutral08: '#334444',
  bColorneutral09: '#111515',
  bColorprimary01: '#99ccbb',
  bColorprimary02: '#66bb99',
  bColorprimary03: '#11bb77',
  bColorprimary04: '#228855',
  bColorprimary05: '#005533',
  bColorsecondary01: '#ddeeff',
  bColorsecondary02: '#ccddee',
  bColorsecondary03: '#99bbdd',
  bColorsecondary04: '#6699dd',
  bColorsecondary05: '#3377bb',
  bColorsecondary06: '#005599',
  bColorsecondary07: '#113377',
  bColorsuccess: '#00dd88',
  bColorsuccesslight: '#ddffee',
  bColorwarning: '#ff7711',
  bColorwarninglight: '#fff1dd',
  uOpacity05: 'rgba(119, 136, 136, 0.05)',
  uOpacity10: 'rgba(119, 136, 136, 0.1)',
  uOpacity20: 'rgba(119, 136, 136, 0.2)',
  uOpacity40: 'rgba(119, 136, 136, 0.4)',
  uOpacity60: 'rgba(119, 136, 136, 0.6)',
  uOpacity80: 'rgba(119, 136, 136, 0.8)',
  uShadow00: '#ffffff',
  uShadow02: '#ffffff',
  uShadow04: '#ffffff',
  uShadow08: '#ffffff',
  uShadow16: '#ffffff',
  uShadowinvert: '#ffffff',
  uSurfaceDisabled: '#f8f8f8',
  uSurfaceFloating: '#ffffff',
  uSurfaceHover: '#ffffff',
  uSurfacePressed: '#ccddee',
  uSurfaceRested: '#ffffff',
  uSurfaceSelected: '#ddeeff',
  uSurfaceShadow: '#ffffff',
  h1BoldFontSize: '32px',
  h1BoldColor: '#111515',
  h1BoldLineHeight: '48px',
  h1BoldFontFamily: 'Nunito',
  h1BoldFontWeight: '700',
  h1BoldTextAlign: 'left',
  h1RegularFontSize: '32px',
  h1RegularColor: '#111515',
  h1RegularLineHeight: '48px',
  h1RegularFontFamily: 'Nunito',
  h1RegularFontWeight: '400',
  h1RegularTextAlign: 'left',
  h1SemiboldFontSize: '32px',
  h1SemiboldColor: '#111515',
  h1SemiboldLineHeight: '48px',
  h1SemiboldFontFamily: 'Nunito',
  h1SemiboldFontWeight: '600',
  h1SemiboldTextAlign: 'left',
  h2BoldFontSize: '24px',
  h2BoldColor: '#111515',
  h2BoldLineHeight: '40px',
  h2BoldFontFamily: 'Nunito',
  h2BoldFontWeight: '700',
  h2BoldTextAlign: 'left',
  h2RegularFontSize: '24px',
  h2RegularColor: '#111515',
  h2RegularLineHeight: '40px',
  h2RegularFontFamily: 'Nunito',
  h2RegularFontWeight: '400',
  h2RegularTextAlign: 'left',
  h2SemiboldFontSize: '24px',
  h2SemiboldColor: '#111515',
  h2SemiboldLineHeight: '40px',
  h2SemiboldFontFamily: 'Nunito',
  h2SemiboldFontWeight: '600',
  h2SemiboldTextAlign: 'left',
  h3BoldFontSize: '20px',
  h3BoldColor: '#111515',
  h3BoldLineHeight: '32px',
  h3BoldFontFamily: 'Nunito',
  h3BoldFontWeight: '700',
  h3BoldTextAlign: 'left',
  h3RegularFontSize: '20px',
  h3RegularColor: '#111515',
  h3RegularLineHeight: '32px',
  h3RegularFontFamily: 'Nunito',
  h3RegularFontWeight: '400',
  h3RegularTextAlign: 'left',
  h3SemiboldFontSize: '20px',
  h3SemiboldColor: '#111515',
  h3SemiboldLineHeight: '32px',
  h3SemiboldFontFamily: 'Nunito',
  h3SemiboldFontWeight: '600',
  h3SemiboldTextAlign: 'left',
  h4BoldFontSize: '18px',
  h4BoldColor: '#111515',
  h4BoldLineHeight: '30px',
  h4BoldFontFamily: 'Nunito',
  h4BoldFontWeight: '700',
  h4BoldTextAlign: 'left',
  h4RegularFontSize: '18px',
  h4RegularColor: '#111515',
  h4RegularLineHeight: '30px',
  h4RegularFontFamily: 'Nunito',
  h4RegularFontWeight: '400',
  h4RegularTextAlign: 'left',
  h4SemiboldFontSize: '18px',
  h4SemiboldColor: '#111515',
  h4SemiboldLineHeight: '30px',
  h4SemiboldFontFamily: 'Nunito',
  h4SemiboldFontWeight: '600',
  h4SemiboldTextAlign: 'left',
  largeBoldFontSize: '18px',
  largeBoldColor: '#111515',
  largeBoldLineHeight: '30px',
  largeBoldFontFamily: 'Nunito Sans',
  largeBoldFontWeight: '700',
  largeBoldTextAlign: 'left',
  largeRegularFontSize: '18px',
  largeRegularColor: '#111515',
  largeRegularLineHeight: '30px',
  largeRegularFontFamily: 'Nunito Sans',
  largeRegularFontWeight: '400',
  largeRegularTextAlign: 'left',
  largeSemiboldFontSize: '18px',
  largeSemiboldColor: '#111515',
  largeSemiboldLineHeight: '30px',
  largeSemiboldFontFamily: 'Nunito Sans',
  largeSemiboldFontWeight: '600',
  largeSemiboldTextAlign: 'left',
  mediumBoldFontSize: '16px',
  mediumBoldColor: '#111515',
  mediumBoldLineHeight: '24px',
  mediumBoldFontFamily: 'Nunito Sans',
  mediumBoldFontWeight: '700',
  mediumBoldTextAlign: 'left',
  mediumRegularFontSize: '16px',
  mediumRegularColor: '#111515',
  mediumRegularLineHeight: '24px',
  mediumRegularFontFamily: 'Nunito Sans',
  mediumRegularFontWeight: '400',
  mediumRegularTextAlign: 'left',
  mediumSemiboldFontSize: '16px',
  mediumSemiboldColor: '#111515',
  mediumSemiboldLineHeight: '24px',
  mediumSemiboldFontFamily: 'Nunito Sans',
  mediumSemiboldFontWeight: '600',
  mediumSemiboldTextAlign: 'left',
  smallBoldFontSize: '14px',
  smallBoldColor: '#111515',
  smallBoldLineHeight: '20px',
  smallBoldFontFamily: 'Nunito Sans',
  smallBoldFontWeight: '700',
  smallBoldTextAlign: 'left',
  smallRegularFontSize: '14px',
  smallRegularColor: '#111515',
  smallRegularLineHeight: '20px',
  smallRegularFontFamily: 'Nunito Sans',
  smallRegularFontWeight: '400',
  smallRegularTextAlign: 'left',
  smallSemiboldFontSize: '14px',
  smallSemiboldColor: '#111515',
  smallSemiboldLineHeight: '20px',
  smallSemiboldFontFamily: 'Nunito Sans',
  smallSemiboldFontWeight: '600',
  smallSemiboldTextAlign: 'left',
  xlargeBoldFontSize: '20px',
  xlargeBoldColor: '#111515',
  xlargeBoldLineHeight: '32px',
  xlargeBoldFontFamily: 'Nunito Sans',
  xlargeBoldFontWeight: '700',
  xlargeBoldTextAlign: 'left',
  xlargeRegularFontSize: '20px',
  xlargeRegularColor: '#111515',
  xlargeRegularLineHeight: '32px',
  xlargeRegularFontFamily: 'Nunito Sans',
  xlargeRegularFontWeight: '400',
  xlargeRegularTextAlign: 'left',
  xlargeSemiboldFontSize: '20px',
  xlargeSemiboldColor: '#111515',
  xlargeSemiboldLineHeight: '32px',
  xlargeSemiboldFontFamily: 'Nunito Sans',
  xlargeSemiboldFontWeight: '600',
  xlargeSemiboldTextAlign: 'left',
  bHeadingh1FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh1FontSize: '72px',
  bHeadingh1LetterSpacing: '0px',
  bHeadingh1LineHeight: '80px',
  bHeadingh1FontWeight: '500',
  bHeadingh1Color: 'black',
  bHeadingh1FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh1FallbackFontSize: '72px',
  bHeadingh1FallbackLetterSpacing: '0px',
  bHeadingh1FallbackLineHeight: '80px',
  bHeadingh1FallbackFontWeight: '400',
  bHeadingh1FallbackColor: 'black',
  bHeadingh1SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh1SystemFontSize: '72px',
  bHeadingh1SystemLetterSpacing: '0px',
  bHeadingh1SystemLineHeight: '80px',
  bHeadingh1SystemFontWeight: '400',
  bHeadingh1SystemColor: 'black',
  bHeadingh2FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh2FontSize: '56px',
  bHeadingh2LetterSpacing: '0px',
  bHeadingh2LineHeight: '64px',
  bHeadingh2FontWeight: '500',
  bHeadingh2Color: 'black',
  bHeadingh2FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh2FallbackFontSize: '56px',
  bHeadingh2FallbackLetterSpacing: '0px',
  bHeadingh2FallbackLineHeight: '64px',
  bHeadingh2FallbackFontWeight: '400',
  bHeadingh2FallbackColor: 'black',
  bHeadingh2SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh2SystemFontSize: '56px',
  bHeadingh2SystemLetterSpacing: '0px',
  bHeadingh2SystemLineHeight: '64px',
  bHeadingh2SystemFontWeight: '400',
  bHeadingh2SystemColor: 'black',
  bHeadingh3FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh3FontSize: '40px',
  bHeadingh3LetterSpacing: '0px',
  bHeadingh3LineHeight: '48px',
  bHeadingh3FontWeight: '500',
  bHeadingh3Color: 'black',
  bHeadingh3FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh3FallbackFontSize: '40px',
  bHeadingh3FallbackLetterSpacing: '0px',
  bHeadingh3FallbackLineHeight: '48px',
  bHeadingh3FallbackFontWeight: '400',
  bHeadingh3FallbackColor: 'black',
  bHeadingh3SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh3SystemFontSize: '40px',
  bHeadingh3SystemLetterSpacing: '0px',
  bHeadingh3SystemLineHeight: '48px',
  bHeadingh3SystemFontWeight: '400',
  bHeadingh3SystemColor: 'black',
  bHeadingh4FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh4FontSize: '32px',
  bHeadingh4LetterSpacing: '0px',
  bHeadingh4LineHeight: '40px',
  bHeadingh4FontWeight: '500',
  bHeadingh4Color: 'black',
  bHeadingh4FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh4FallbackFontSize: '32px',
  bHeadingh4FallbackLetterSpacing: '0px',
  bHeadingh4FallbackLineHeight: '40px',
  bHeadingh4FallbackFontWeight: '400',
  bHeadingh4FallbackColor: 'black',
  bHeadingh4SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh4SystemFontSize: '32px',
  bHeadingh4SystemLetterSpacing: '0px',
  bHeadingh4SystemLineHeight: '40px',
  bHeadingh4SystemFontWeight: '400',
  bHeadingh4SystemColor: 'black',
  bHeadingh5FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh5FontSize: '24px',
  bHeadingh5LetterSpacing: '0px',
  bHeadingh5LineHeight: '32px',
  bHeadingh5FontWeight: '500',
  bHeadingh5Color: 'black',
  bHeadingh5FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh5FallbackFontSize: '24px',
  bHeadingh5FallbackLetterSpacing: '0px',
  bHeadingh5FallbackLineHeight: '32px',
  bHeadingh5FallbackFontWeight: '400',
  bHeadingh5FallbackColor: 'black',
  bHeadingh5SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh5SystemFontSize: '24px',
  bHeadingh5SystemLetterSpacing: '0px',
  bHeadingh5SystemLineHeight: '32px',
  bHeadingh5SystemFontWeight: '400',
  bHeadingh5SystemColor: 'black',
  bHeadingh6FontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bHeadingh6FontSize: '20px',
  bHeadingh6LetterSpacing: '0px',
  bHeadingh6LineHeight: '28px',
  bHeadingh6FontWeight: '500',
  bHeadingh6Color: 'black',
  bHeadingh6FallbackFontFamily: '"Arial", "ArialMT"',
  bHeadingh6FallbackFontSize: '16px',
  bHeadingh6FallbackLetterSpacing: '0px',
  bHeadingh6FallbackLineHeight: '24px',
  bHeadingh6FallbackFontWeight: '400',
  bHeadingh6FallbackColor: 'black',
  bHeadingh6SystemFontFamily: '"Arial", "ArialMT"',
  bHeadingh6SystemFontSize: '16px',
  bHeadingh6SystemLetterSpacing: '0px',
  bHeadingh6SystemLineHeight: '24px',
  bHeadingh6SystemFontWeight: '400',
  bHeadingh6SystemColor: 'black',
  bLabalcaptionFallbackFontFamily: '"Arial", "ArialMT"',
  bLabalcaptionFallbackFontSize: '12px',
  bLabalcaptionFallbackLetterSpacing: '0px',
  bLabalcaptionFallbackLineHeight: '16px',
  bLabalcaptionFallbackFontWeight: '400',
  bLabalcaptionFallbackColor: 'black',
  bLabelactionFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Bold"',
  bLabelactionFontSize: '16px',
  bLabelactionLetterSpacing: '0px',
  bLabelactionLineHeight: '24px',
  bLabelactionFontWeight: '700',
  bLabelactionTextDecoration: 'underline',
  bLabelactionColor: 'black',
  bLabelactionFallbackFontFamily: '"Arial", "Arial-BoldMT"',
  bLabelactionFallbackFontSize: '16px',
  bLabelactionFallbackLetterSpacing: '0px',
  bLabelactionFallbackLineHeight: '24px',
  bLabelactionFallbackFontWeight: '700',
  bLabelactionFallbackTextDecoration: 'underline',
  bLabelactionFallbackColor: 'black',
  bLabelbuttonFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Bold"',
  bLabelbuttonFontSize: '20px',
  bLabelbuttonLetterSpacing: '0px',
  bLabelbuttonLineHeight: '28px',
  bLabelbuttonFontWeight: '700',
  bLabelbuttonColor: 'black',
  bLabelbuttonFallbackFontFamily: '"Arial", "Arial-BoldMT"',
  bLabelbuttonFallbackFontSize: '20px',
  bLabelbuttonFallbackLetterSpacing: '0px',
  bLabelbuttonFallbackLineHeight: '28px',
  bLabelbuttonFallbackFontWeight: '700',
  bLabelbuttonFallbackColor: 'black',
  bLabelcaptionFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bLabelcaptionFontSize: '12px',
  bLabelcaptionLetterSpacing: '0px',
  bLabelcaptionLineHeight: '16px',
  bLabelcaptionFontWeight: '500',
  bLabelcaptionColor: 'black',
  bLabelformFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Medium"',
  bLabelformFontSize: '16px',
  bLabelformLetterSpacing: '0px',
  bLabelformLineHeight: '24px',
  bLabelformFontWeight: '500',
  bLabelformColor: 'black',
  bLabelformFallbackFontFamily: '"Arial", "Arial-BoldMT"',
  bLabelformFallbackFontSize: '16px',
  bLabelformFallbackLetterSpacing: '0px',
  bLabelformFallbackLineHeight: '24px',
  bLabelformFallbackFontWeight: '700',
  bLabelformFallbackColor: 'black',
  bTextparagraphFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Light"',
  bTextparagraphFontSize: '20px',
  bTextparagraphLetterSpacing: '0px',
  bTextparagraphLineHeight: '28px',
  bTextparagraphFontWeight: '300',
  bTextparagraphColor: 'black',
  bTextparagraphFallbackFontFamily: '"Arial", "ArialMT"',
  bTextparagraphFallbackFontSize: '20px',
  bTextparagraphFallbackLetterSpacing: '0px',
  bTextparagraphFallbackLineHeight: '28px',
  bTextparagraphFallbackFontWeight: '400',
  bTextparagraphFallbackColor: 'black',
  bTextparagraphSystemFontFamily: '"Arial", "ArialMT"',
  bTextparagraphSystemFontSize: '16px',
  bTextparagraphSystemLetterSpacing: '0px',
  bTextparagraphSystemLineHeight: '24px',
  bTextparagraphSystemFontWeight: '400',
  bTextparagraphSystemColor: 'black',
  bTextsupportFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Light"',
  bTextsupportFontSize: '16px',
  bTextsupportLetterSpacing: '0px',
  bTextsupportLineHeight: '24px',
  bTextsupportFontWeight: '300',
  bTextsupportColor: 'black',
  bTextsupportFallbackFontFamily: '"Arial", "ArialMT"',
  bTextsupportFallbackFontSize: '16px',
  bTextsupportFallbackLetterSpacing: '0px',
  bTextsupportFallbackLineHeight: '24px',
  bTextsupportFallbackFontWeight: '400',
  bTextsupportFallbackColor: 'black',
  bTextsupportSystemFontFamily: '"Arial", "ArialMT"',
  bTextsupportSystemFontSize: '14px',
  bTextsupportSystemLetterSpacing: '0px',
  bTextsupportSystemLineHeight: '20px',
  bTextsupportSystemFontWeight: '400',
  bTextsupportSystemColor: 'black',
  bTextsupportformFontFamily: '"Helvetica Now Display", "HelveticaNowDisplay-Light"',
  bTextsupportformFontSize: '14px',
  bTextsupportformLetterSpacing: '0px',
  bTextsupportformLineHeight: '20px',
  bTextsupportformFontWeight: '300',
  bTextsupportformColor: 'black',
  bTextsupportformFallbackFontFamily: '"Arial", "ArialMT"',
  bTextsupportformFallbackFontSize: '14px',
  bTextsupportformFallbackLetterSpacing: '0px',
  bTextsupportformFallbackLineHeight: '20px',
  bTextsupportformFallbackFontWeight: '400',
  bTextsupportformFallbackColor: 'black'
};